var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg-settings",
    transform: "translate(-1496 -44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "form",
    transform: "translate(1496 44)",
    fill: "none",
    stroke: "#73a91b",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-settings",
    "data-name": "Icon feather-settings",
    transform: "translate(1507.908 55.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86505",
    "data-name": "Path 86505",
    d: "M20.788,17.144A3.644,3.644,0,1,1,17.144,13.5,3.644,3.644,0,0,1,20.788,17.144Z",
    transform: "translate(-3.783 -3.783)",
    fill: "none",
    stroke: "#73a91b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86506",
    "data-name": "Path 86506",
    d: "M23.85,18.505a2,2,0,0,0,.4,2.211l.073.073a2.431,2.431,0,1,1-3.438,3.438l-.073-.073a2.02,2.02,0,0,0-3.425,1.433v.206a2.429,2.429,0,0,1-4.859,0v-.109a2,2,0,0,0-1.312-1.834,2,2,0,0,0-2.211.4l-.073.073A2.431,2.431,0,1,1,5.5,20.886l.073-.073a2.02,2.02,0,0,0-1.433-3.425H3.929a2.429,2.429,0,1,1,0-4.859h.109a2,2,0,0,0,1.834-1.312,2,2,0,0,0-.4-2.211L5.4,8.934A2.431,2.431,0,1,1,8.837,5.5l.073.073a2,2,0,0,0,2.211.4h.1a2,2,0,0,0,1.215-1.834V3.929a2.429,2.429,0,1,1,4.859,0v.109a2.02,2.02,0,0,0,3.425,1.433l.073-.073a2.431,2.431,0,1,1,3.438,3.438l-.073.073a2,2,0,0,0-.4,2.211v.1a2,2,0,0,0,1.834,1.215h.206a2.429,2.429,0,0,1,0,4.859h-.109a2,2,0,0,0-1.834,1.215Z",
    transform: "translate(-1.5 -1.5)",
    fill: "none",
    stroke: "#73a91b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgSettings);
export default __webpack_public_path__ + "static/media/svg-settings.aa79adb179f96b5271dec718ed52d9d1.svg";
export { ForwardRef as ReactComponent };